import {createFileRoute} from "@tanstack/react-router";
import {AuthPage} from "@/containers/auth/AuthPage";

export const Route = createFileRoute("/auth/sign-in")({
  component: AuthPage,
});
